import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/AuthContext";
import { Palette, Save } from "lucide-react";
import { toast } from "sonner";
import SignatureSettings from "@/components/SignatureSettings";

export default function AdminSettings() {
  const { user } = useAuth();
  const [company, setCompany] = useState(null);
  const [form, setForm] = useState({ name: "", primary_color: "#1a3a5c", secondary_color: "#c8232c", white_label_domain: "", logo_url: "" });

  useEffect(() => {
    if (!user?.company_id) return;
    api.get(`/companies/${user.company_id}`).then((r) => {
      setCompany(r.data);
      setForm({
        name: r.data.name || "",
        primary_color: r.data.primary_color || "#1a3a5c",
        secondary_color: r.data.secondary_color || "#c8232c",
        white_label_domain: r.data.white_label_domain || "",
        logo_url: r.data.logo_url || "",
      });
    });
  }, [user]);

  const save = async () => {
    await api.patch(`/companies/${user.company_id}`, form);
    toast.success("Configurações atualizadas");
  };

  if (!user?.company_id) {
    return <div className="text-slate-500">Sem empresa vinculada.</div>;
  }

  return (
    <div className="space-y-8" data-testid="admin-settings-page">
      <header>
        <div className="eyebrow">White label</div>
        <h1 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight mt-1 flex items-center gap-3"><Palette className="w-7 h-7 text-[var(--unigr-red)]" />Configurações da empresa</h1>
        <p className="text-slate-600 mt-2 text-sm">Personalize cores, logo e domínio próprio da sua plataforma.</p>
      </header>
      <Card><CardContent className="p-6 space-y-4">
        <div className="grid sm:grid-cols-2 gap-4">
          <div><Label>Nome da empresa</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="settings-name" /></div>
          <div><Label>Domínio próprio (white label)</Label><Input value={form.white_label_domain} onChange={(e) => setForm({ ...form, white_label_domain: e.target.value })} placeholder="universidade.suaempresa.com.br" /></div>
          <div><Label>Cor primária</Label><Input type="color" value={form.primary_color} onChange={(e) => setForm({ ...form, primary_color: e.target.value })} /></div>
          <div><Label>Cor secundária</Label><Input type="color" value={form.secondary_color} onChange={(e) => setForm({ ...form, secondary_color: e.target.value })} /></div>
          <div className="sm:col-span-2"><Label>Logo (URL)</Label><Input value={form.logo_url} onChange={(e) => setForm({ ...form, logo_url: e.target.value })} placeholder="https://..." /></div>
        </div>
        <Button onClick={save} className="btn-navy" data-testid="settings-save-btn"><Save className="w-4 h-4 mr-2" />Salvar configurações</Button>
      </CardContent></Card>

      <SignatureSettings />
    </div>
  );
}
